import { z } from "zod";
import type { IngestionJobStatusResponse, ParserKey, SharePointSite } from "@noa/api-core";

export const SITE_OPTIONS: { value: SharePointSite; label: string }[] = [
  { value: "ingenierie", label: "Ingénierie (Plans)" },
  { value: "librairie_maximo", label: "LibrairieMaximo (Procédures)" },
];

export const PARSER_OPTIONS: { value: ParserKey; label: string }[] = [
  { value: "DESCRIPTION", label: "Description (rich chunk)" },
  { value: "PDF_FAST", label: "PDF Fast (text docs)" },
  { value: "PDF", label: "PDF (Docling)" },
];

// A Select cleared with its "×" reports `undefined`, not `null`: `.nullish()` accepts both,
// where `.nullable()` made the form invalid and the sync button silently inert.
export const sharePointSyncSchema = z.object({
  site: z.string().nullish(),
  schemaId: z.string().nullish(),
  parser: z.enum(["PDF", "PDF_FAST", "DOCX", "HTML", "TXT", "MARKDOWN", "IMAGE", "DESCRIPTION"]).nullish(),
  withVision: z.boolean(),
  skipExisting: z.boolean(),
  limitEnabled: z.boolean(),
  maxRecords: z.number().int().min(1).max(10000),
});

export type SharePointSyncForm = z.infer<typeof sharePointSyncSchema>;

export const sharePointSyncDefaultValues: SharePointSyncForm = {
  site: null,
  schemaId: null,
  parser: null,
  withVision: true,
  // Matches the backend default and the ConformIT form. Once trigger options
  // reach cloud runs, false would re-ingest every document already indexed.
  skipExisting: true,
  limitEnabled: false,
  maxRecords: 10,
};

export type RelaunchSource = Pick<
  IngestionJobStatusResponse,
  "site" | "schema_id" | "parser" | "with_vision" | "max_records" | "skip_existing"
>;

/** The form of the sync a job ran, to run it again: an incremental sync resumes where it stopped. */
export function relaunchValues(job: RelaunchSource): SharePointSyncForm {
  return {
    ...sharePointSyncDefaultValues,
    site: job.site ?? null,
    schemaId: job.schema_id ?? null,
    parser: job.parser ?? null,
    withVision: job.with_vision ?? sharePointSyncDefaultValues.withVision,
    skipExisting: job.skip_existing ?? sharePointSyncDefaultValues.skipExisting,
    limitEnabled: job.max_records != null,
    maxRecords: job.max_records ?? sharePointSyncDefaultValues.maxRecords,
  };
}
